import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import UtmsButton from '../ui/UtmsButton';

const ModalDelete = ({ open, setOpen, objectName, handleSubmit, customRevertChangesMessage = '', content = <></> }) => {
    const { t } = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitButton = () => {
        handleSubmit();
        handleClose();
    };

    return (
        <Dialog
            PaperProps={{
                sx: {
                    width: '444px',
                },
            }}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle variant="h4">{`${t('delete')} ${objectName || t('object')}?`}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
                    {customRevertChangesMessage !== false &&
                        (customRevertChangesMessage || t('revert_changes_message_2'))}
                </DialogContentText>
                {content}
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleSubmitButton} autoFocus color="error">
                    {t('delete')}
                </UtmsButton>
                <UtmsButton onClick={handleClose} color="secondary">
                    {t('cancel')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDelete;
